import type { Theme } from "@mui/material";

export const sliderStyles = (disabled: boolean, theme: Theme) => {
  return {
    color: "#FFCF96",
    "& .MuiSlider-track": {
      border: "none",
      color: disabled ? theme.palette.natural.t3 : undefined,
    },
    "& .MuiSlider-thumb": {
      width: 20,
      height: 20,
      borderRadius: 0,
      background: disabled
        ? theme.palette.natural.t3
        : theme.palette.main.gradient.primary.p2,
      "&:before": {
        boxShadow: "0 2px 4px rgba(0,0,0,0.4)",
      },
      "&:hover, &.Mui-focusVisible, &.Mui-active": {
        boxShadow: "none",
      },
    },
  };
};
